"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppSettingsStuckClaims = void 0;
const button_1 = require("client/components/material/button");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const store_1 = require("../../store");
require("./app-settings-stuck-claims.less");
const select_1 = require("client/components/material/select");
const store_2 = require("client/modules/sites/modules/sites-list/store");
const core_1 = require("@material-ui/core");
const optionData_1 = require("./optionData");
//E-096 extra B-049.611
let AppSettingsStuckClaims = class AppSettingsStuckClaims extends React.Component {
    constructor() {
        super(...arguments);
        this.siteId = "";
        this.claimData = [];
        this.claimDataOriginal = [];
        this.selectedItems = [];
        this.handleSubmit = async () => {
            const payload = this.claimData.filter((item) => this.selectedItems.includes(item.id));
            const updated = await store_1.appSettingsStore.updateStuckedClaimData(payload);
            if (updated.success) {
                const result = await store_1.appSettingsStore.readStuckClaimData(Number(this.siteId));
                this.claimData = result;
                this.claimDataOriginal = result;
            }
        };
        this.handleSearch = async () => {
            const result = await store_1.appSettingsStore.readStuckClaimData(Number(this.siteId));
            this.claimData = result;
            this.claimDataOriginal = result;
        };
        // eslint-disable-next-line @typescript-eslint/member-ordering
        this.renderPoIntentQtyList = () => (this.claimData || []).map((intent, index) => {
            const { displayName, patientName, providerName, status, id, newStatus } = intent;
            return (React.createElement(core_1.TableRow, { key: index },
                React.createElement(core_1.TableCell, null,
                    React.createElement("input", { type: "checkbox", checked: this.selectedItems.includes(id), onClick: (e) => this.handleListChnage(e, id) })),
                React.createElement(core_1.TableCell, null, index + 1 || ""),
                React.createElement(core_1.TableCell, null,
                    React.createElement("a", { href: `/claims/${id}`, target: "_blank", style: { cursor: "pointer" } }, id || "")),
                React.createElement(core_1.TableCell, null, displayName || ""),
                React.createElement(core_1.TableCell, null, patientName || ""),
                React.createElement(core_1.TableCell, null, providerName || ""),
                React.createElement(core_1.TableCell, null,
                    React.createElement("span", { className: "dot" }, ""),
                    React.createElement("span", null, "In Progress" || "")),
                React.createElement(core_1.TableCell, null,
                    React.createElement("select", { style: { height: "27px", borderRadius: "5px", zIndex: 1 }, value: newStatus || status, defaultValue: status, onChange: (e) => this.handleStatusChange(e.target.value, id) }, optionData_1.statusOptions.map(option => (React.createElement("option", { key: option.value, value: option.value, style: { color: option.color } }, option.label)))))));
        });
        this.handleHeaderCheckboxChange = (event) => {
            if (event.target.checked) {
                // Select all items
                this.selectedItems = this.claimData.map((item) => item.id);
            }
            else {
                // Unselect all items
                this.selectedItems = [];
            }
        };
    }
    async componentDidMount() {
        await store_2.sitesListStore.loadSitesNoRelation();
    }
    componentWillUnmount() { }
    get availableSites() {
        const options = [];
        if (store_2.sitesListStore.sites.value) {
            store_2.sitesListStore.sites.value.forEach((site, i) => {
                options.push({
                    id: i,
                    label: site.displayName || site.name,
                    value: site.id
                });
            });
        }
        options.unshift({
            id: 0,
            label: "All pharmacies",
            value: "0"
        });
        return options;
    }
    renderSettings() {
        const head = React.createElement("h2", null, "Stuck Claims");
        const search = (React.createElement("div", { style: {
                alignItems: "center",
                display: "flex",
                justifyContent: "space-around",
                margin: "2em auto 0",
                width: "80%"
            } },
            React.createElement(select_1.MaterialSelect, { options: this.availableSites, value: this.siteId, label: "Pharmacy", searchable: true, onSelect: e => {
                    this.siteId = e;
                } }),
            React.createElement("div", null,
                React.createElement(button_1.MaterialButton, { disabled: !`${this.siteId}`.length, onClick: this.handleSearch, style: { marginLeft: "1em" }, primary: true }, "Search")),
            React.createElement(button_1.MaterialButton, { onClick: this.handleSubmit, disabled: this.selectedItems.length === 0, primary: true }, "Save")));
        const content = (React.createElement("div", { style: { padding: "0 10em 5em" } },
            head,
            search));
        return content;
    }
    handleListChnage(e, item) {
        if (e.target.checked) {
            this.selectedItems = [...this.selectedItems, item];
        }
        else {
            this.selectedItems = this.selectedItems.filter((selectedItem) => selectedItem !== item);
        }
    }
    ;
    handleStatusChange(value, rowId) {
        const updatedData = this.claimData.map((item) => rowId === item.id ? Object.assign(Object.assign({}, item), { newStatus: value }) : item);
        this.claimData = updatedData;
    }
    renderStuckClaimTable() {
        const table = (React.createElement("div", null,
            React.createElement("div", { className: "stcuk-table" },
                React.createElement(core_1.Table, null,
                    React.createElement(core_1.TableHead, { className: "stcuk-table__head", style: { position: 'sticky', top: '0' } },
                        React.createElement(core_1.TableRow, { className: "stcuk-table__head-row" },
                            React.createElement(core_1.TableCell, { className: "stcuk-table__head-row__cell" },
                                React.createElement("input", { type: "checkbox", onClick: (e) => this.handleHeaderCheckboxChange(e) })),
                            React.createElement(core_1.TableCell, { className: "stcuk-table__head-row__cell" }, "Sr.No"),
                            React.createElement(core_1.TableCell, { className: "stcuk-table__head-row__cell" }, "Claim Number"),
                            React.createElement(core_1.TableCell, { className: "stcuk-table__head-row__cell" }, "Pharmacy Name"),
                            React.createElement(core_1.TableCell, { className: "stcuk-table__head-row__cell" }, "PatientName"),
                            React.createElement(core_1.TableCell, { className: "stcuk-table__head-row__cell" }, "providerName"),
                            React.createElement(core_1.TableCell, { className: "stcuk-table__head-row__cell" }, "Status"),
                            React.createElement(core_1.TableCell, { className: "stcuk-table__head-row__cell" }, "Modified To"))),
                    React.createElement(core_1.TableBody, { className: "stcuk-table__body" }, this.renderPoIntentQtyList())))));
        const hasSearch = !this.claimDataOriginal.length;
        const content = (React.createElement("div", { style: { padding: "0 10em 5em" } },
            table,
            hasSearch ? (React.createElement("p", { style: { textAlign: "center" } }, "Stuck cliam not found.")) : (React.createElement(React.Fragment, null))));
        return content;
    }
    render() {
        const didLoad = true;
        return (React.createElement("div", null,
            didLoad ? this.renderSettings() : React.createElement("p", null, "Component is loading."),
            this.renderStuckClaimTable()));
    }
};
__decorate([
    mobx_1.observable
], AppSettingsStuckClaims.prototype, "siteId", void 0);
__decorate([
    mobx_1.observable
], AppSettingsStuckClaims.prototype, "claimData", void 0);
__decorate([
    mobx_1.observable
], AppSettingsStuckClaims.prototype, "claimDataOriginal", void 0);
__decorate([
    mobx_1.observable
], AppSettingsStuckClaims.prototype, "selectedItems", void 0);
__decorate([
    mobx_1.computed
], AppSettingsStuckClaims.prototype, "availableSites", null);
AppSettingsStuckClaims = __decorate([
    mobx_react_1.observer
], AppSettingsStuckClaims);
exports.AppSettingsStuckClaims = AppSettingsStuckClaims;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/app-settings/tabs/app-settings-stuck-claims/app-settings-stuck-claims.tsx
// module id = 3209
// module chunks = 0